import { CoordinatorService } from './coordinator.service';
import { Table } from './table';
import { TableCell } from './table-cell';
import { TAGTEMPL } from './template-repository$';

export class TableRow {
    private _id: string;
    label: string;
    inEditOnly: boolean;
    isHidden: boolean;
    cellLs: TableCell[] = [];

    constructor(
        private coords: CoordinatorService,
        public tbl: Table,
        params: TAGTEMPL,
    ) {
        this._id = this.coords.uniqueId();
        this.label = params.label || params.tag;
        this.cellLs = [new TableCell(this.coords, this, params)];
        this.isHidden = params.hide || false;
        this.inEditOnly = !!params.inEditOnly;
    }

    get title() {
        return this.coords.text(this.label);
    }

    addCell(params: TAGTEMPL) {
        const td = new TableCell(this.coords, this, params);
        this.cellLs.push(td);
        return td;
    }

    get hasPin() {
        return this.tbl.pin?.has(this._id);
    }

    switchPin() {
        this.tbl.pin?.switch(this._id);
    }
}
